<script>
import { getSaleType } from "@src/helpers/sale";
import { getPaymentMethod } from "@src/helpers/payment";
import { formatDateLongBR } from "@src/helpers/date";
import SaleStatusBadge from "@src/components/ui-design/badges/SaleStatusBadge.vue";
import Badge from "@src/components/ui-design/badges/Badge.vue";
import CalendarIcon from "@src/assets/img/icons/pages/sales/calendar.svg";

const RECURRENCE_STATUS = {
  created: { label: "Criada", variant: "info" },
  trialing: { label: "Em avaliação", variant: "info" },
  paid: { label: "Ativa", variant: "success" },
  unpaid: { label: "Não paga", variant: "danger" },
  ended: { label: "Encerrada", variant: "secondary" },
  canceled: { label: "Cancelada", variant: "danger" },
  waiting_payment: { label: "Aguardando pag.", variant: "warning" },
  pending_payment: { label: "Pag. pendente", variant: "warning" },
  processing: { label: "Canc. em andamento", variant: "info" },
};

export default {
  components: {
    SaleStatusBadge,
    Badge,
  },
  props: {
    sale: {
      type: Object,
      required: true,
    },
  },
  computed: {
    productName() {
      return this.sale && this.sale.product ? this.sale.product.name : "";
    },
    saleStatus() {
      return this.sale && this.sale.status ? this.sale.status : "";
    },
    recurrenceStatus() {
      if (!this.sale || !["SUBSCRIPTION", "CONTRACT"].includes(this.sale.type)) {
        return null;
      }

      const status = this.sale && this.sale.client_contract && this.sale.client_contract.status;

      return RECURRENCE_STATUS[status] || null;
    },
  },
  data() {
    return {
      CalendarIcon,
    };
  },
  methods: {
    getPaymentMethod,
    getSaleType,
    formatDateLongBR
  }
};
</script>

<template>
  <div class="sales-resume card-box p-3 px-0">
    <h6 class="sales-details__subtitle">Resumo da Venda</h6>
    <div class="row mb-3">
      <div class="col-6 mb-2">
        <div>ID da Transação</div>
        <p class="sales-resume__id">{{ sale.transaction_id ? `#${sale.transaction_id}` : '' }}</p>
      </div>
      <div class="col-6 mb-2">
        <div>ID Greenn</div>
        <p class="sales-resume__id">#{{ sale.id }}</p>
      </div>
      <div class="col-6 mb-2">
        <div>Status</div>
        <SaleStatusBadge :status="saleStatus" />
      </div>
      <div class="col-6 mb-2">
        <div>Tipo de Venda</div>
        <div class="sales-resume__sale-type">
          <p>{{ getSaleType(sale.type) }}</p>
          <Badge
            v-if="recurrenceStatus"
            :label="recurrenceStatus.label"
            :variant="recurrenceStatus.variant"
            :aria-label="`Status da recorrência: ${recurrenceStatus.label}`"
          />
        </div>
      </div>
      <div class="col-6">
        <div>Método de Pagamento</div>
        <p>{{ getPaymentMethod(sale.method) }}</p>
      </div>
      <div class="col-6">
        <div>Data da Venda</div>
        <div class="d-flex align-items-center mt-1 gap-1">
          <img class="mr-1" :src="CalendarIcon" alt="Ícone de calendário" />
          <p>{{ formatDateLongBR(sale.created_at) }}</p>
        </div>
      </div>
    </div>

    <div class="sales-details__bar"></div>

    <div class="d-flex justify-content-between">
      <div>
        <div>Produto</div>
        <p>{{ productName }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sales-resume__id {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.sales-resume__sale-type {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.sales-resume__sale-type p {
  margin-bottom: 0;
}

img {
  width: 14px;
}

p {
  color: #000c0b;
}
</style>
